import { gql } from "@apollo/client";

export const RolesQuery = gql`
  query roles {
    roles {
      activeRole
      assignedRoles
    }
  }
`;
